
import React, { useState, useRef } from "react";
import { Box, useTheme, CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Webcam from "react-webcam";
import BaseCard from "../../../components/Cards/Card";
import CustomButton from "../../../components/CustomButton";
import CustomText, { textStyles } from "../../../components/CustomText";
import { useTranslation } from "react-i18next";
import { toast } from "react-hot-toast";
import { BASE_URL } from "../../../components/BaseUrl";
import { setProfileDraft } from "./ProfileDraft";
import useMediaQuery from "@mui/material/useMediaQuery";

const videoConstraints = {
  width: 400,
  height: 250,
  facingMode: "user", // front camera
};
const FaceScanning = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const webcamRef = useRef(null);

  const [capturedImage, setCapturedImage] = useState(null);
  const [uploading, setUploading] = useState(false);
const [loading, setLoading] = useState(false);
  // Capture selfie
  const capture = async () => {
    const imageSrc = webcamRef.current.getScreenshot();
    if (!imageSrc) return;

    setCapturedImage(imageSrc);
    setUploading(true);

    try {
      // Convert base64 → Blob
      const blob = await fetch(imageSrc).then((res) => res.blob());
      const formData = new FormData();
      formData.append("image", blob, "face.jpg");

      const res = await fetch(`${BASE_URL}/upload/image`, {
        method: "POST",
        body: formData,
      });

      const rawText = await res.text();
      let data;
      try {
        data = JSON.parse(rawText);
      } catch {
        toast.error("Invalid server response");
        return;
      }

      if (!res.ok || data.error) {
        toast.error(data.message || "Image upload failed");
        return;
      }

      if (data.data?.url) {
        // Save to draft
        setProfileDraft({ face_image_url: data.data.url });
        toast.success(t("face_captured_saved"));
        navigate("/registration-verification"); // go to next screen
      }
    } catch (err) {
      console.error("❌ Upload error:", err);
      toast.error("Upload failed");
    } finally {
      setUploading(false);
    }
  };
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isLaptop = useMediaQuery(theme.breakpoints.between("md", "lg"));
  return (
    <Box sx={{ py: 6, px: 2 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          minHeight: "100vh",
          alignItems: "center",
        }}
      >
        <BaseCard
        maxWidth={isMobile ? "100%" : isTablet ? "45%" : isLaptop ? "38%" : "38%"}>
          <CustomText
            sx={{
              ...textStyles.h4,
              color: "#172B4D",
              fontSize: "26px",
              mb: 2,
            }}
          >
            {t("faceScanTitle")}
          </CustomText>
          <CustomText
            sx={{ ...textStyles.body5, color: "#6B778C", mb: 3 }}
          >
            {t("faceScanSubtitle")}
          </CustomText>

          {!capturedImage ? (
            <Webcam
              audio={false}
              ref={webcamRef}
              screenshotFormat="image/jpeg"
              videoConstraints={videoConstraints}
              style={{ width: "100%", borderRadius: 8 }}
            />
          ) : (
            <img
              src={capturedImage}
              alt="Captured"
              style={{ width: "100%", borderRadius: 8 }}
            />
          )}

          <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mt: 3 }}>
            {!capturedImage ? (
              <CustomButton
            label={uploading ? t("settings.uploading") : t("settings.faceScanCapture")}
                onClick={capture}
                disabled={uploading}
              />
            ) : (
              <CustomButton
                label={t("retake")}
                onClick={() => setCapturedImage(null)}
              />
            )}
          </Box>
        </BaseCard>
      </Box>
    </Box>
  );
};

export default FaceScanning;

